import Vue from 'vue';
import Vuex from 'vuex';
import auth from './auth.module';
import street from './street.module';
import document from './document.module';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    configuration: {
      cityPictures: [],
      blocs: [],
    },
    layout: 'DefaultLayout',
  },
  getters: {
    configuration: (state) => state.configuration,
    layout: (state) => state.layout,
  },
  actions: {

    setConfiguration({ commit }, configuration) {
      commit('setConfiguration', configuration);
    },
    setLayout({ commit }, layout) {
      commit('setLayout', layout);
    },
  },
  mutations: {
    setConfiguration(state, configuration) {
      const monthIndex = configuration.declarationEnd.split('/')[1] - 1;
      const day = configuration.declarationEnd.split('/')[0];
      configuration.declarationEnd = new Date(new Date(new Date().getFullYear(), monthIndex, day).setHours(23, 59, 59, 999));

      state.configuration = configuration;
    },
    setLayout(state, layout) {
      state.layout = layout;
    },
  },
  modules: {
    street,
    auth,
    document,
  },
});
